import {
  PlaneBufferGeometry
} from 'three'

const planeGeometry = new PlaneBufferGeometry(1, 1, 1, 1)

export {
  planeGeometry
}
